import { Injectable } from '@angular/core';
import { ToastData, ToastOptions, ToastyService } from '@haithamsboui/ng-toasty';
import { TranslatePipe } from '../pipes/translate.pipe';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastyService: ToastyService, private translator: TranslatePipe) {}

  notifyError(messageKey: string, args?: any) {
    const toastOptions = this.resolveOptions(messageKey, args);
    this.toastyService.error(toastOptions);
  }

  notifyWait(toastOptions) {
    this.toastyService.wait(toastOptions);
  }

  notifySuccess(messageKey: string, args?: any) {
    const toastOptions = this.resolveOptions(messageKey, args);
    this.toastyService.success(toastOptions);
  }

  clear(id?: number) {
    if (id) {
      this.toastyService.clear(id);
    } else {
      this.toastyService.clearAll();
    }
  }

  private resolveOptions(messageKey: string, args?: any): ToastOptions {
    return {
      title: this.translator.transform(messageKey, args),
      msg: '',
      showClose: true,
      timeout: 2000,
      theme: 'bootstrap',
      onAdd: (toast: ToastData) => {},
      onRemove: (toast: ToastData) => {},
    };
  }
}
